
export default {
  props: {
    breadcrumbWording: {
      type: Object,
      required: true,
    },
    breadcrumbs: {
      type: Array,
      required: true,
    },
  },
  computed: {
    relatedBreadcrumbLevel() {
      return `level_${this.breadcrumbs.length + 1}`
    },
    parentBreadcrumbKey() {
      return this.breadcrumbs[this.breadcrumbs.length - 1]
    },
    childCategories() {
      if (
        this.breadcrumbWording &&
        this.breadcrumbWording[this.relatedBreadcrumbLevel]
      ) {
        return this.breadcrumbWording[this.relatedBreadcrumbLevel].filter(
          (item) => item.parent_key === this.parentBreadcrumbKey
        )
      } else return []
    },
  },
}
